
export class User {
    constructor() {
      return {
        sys: {
					id: ''
				},
				fields: {
					keycloakId: {de: ''},
					name: {de: ''},
					email: {de: ''},
					password: {de: ''},
					enabled: {de: false},
					type: {de: ''},
					mainOperator: {de: false},
					canManageOperators: {de: false},

					canManageTags: {de: []},
					canSeeObjectsWithTags: {de: []},
					applications: {de: []},
					clients: {de: []},
					dashboard: {de: []},
					packageDesignerConfig: {de: { packageAssignmentMode: {de: 'assignMyself'} }},

					serviceProviderId: {de: ''},
					preferredLanguage: {de : 'de'},

					requires2fa: {de: false},
					metisRoles: {de: []}
				}
    }
  }
}